:host {
  @include cms-default-grid-container;
  margin-bottom: var(--cms-components-mb);
}

.host-inner {
  width: 100%;
  grid-area: var(--cms-default-grid-area);
  --cms-grid-padding: 0;
  @include cms-default-grid-container;
  list-style: none;
}

.error-massage {
  color: var(--cms-semanticColors-error-text);
}

.service-teaser {
  padding: var(--cms-spacing-100);
  grid-area: var(--cms-default-grid-area);
}

.service-teaser:not(.error-massage) {
  background-color: var(--cms-theme-background-color-teaser);
}

.teaser-link {
  --cms-grid-template-columns: 1fr 3fr 1fr;
  --cms-grid-gap: var(--cms-spacing-050);
  @include cms-default-grid-container;
  max-width: 100%;
  color: var(--cms-theme-inverted-text-color);
  align-items: center;
  text-decoration: none;
  font-family: var(--cms-brandfont2);
  font-size: var(--cms-font-size-100);
  line-height: var(--cms-line-height-133);
  height: 100%;
}

.service-icon-wrapper,
.text-wrapper,
.icon-wrapper {
  align-self: center;
}

.service-icon-wrapper {
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.icon-wrapper {
  justify-self: right;
}

.image-wrapper {
  display: block;
  width: 6.375rem;
  height: 4.25rem;
}

.icon-image {
  max-width: 100%;
  width: auto;
  height: auto;
  max-height: 100%;
}

@include media-width($breakpoint-sm) {
  .host-inner {
    --cms-default-grid-area: auto / 2 / auto / span 10;
  }

  .service-teaser {
    --cms-default-grid-area: auto / auto/ auto / span 6;
  }
}

@include media-width($breakpoint-md) {
  .host-inner {
    --cms-default-grid-area: auto / auto / auto / span 12;
  }

  .service-teaser {
    --cms-default-grid-area: auto / auto/ auto / span 4;
  }
}